import { InvoiceRepository } from "../../repositories/InvoiceRepository";
import { InvoiceOperationResult } from "../../entities/InvoiceEntity";

/**
 * Reject Invoice Use Case
 * Marks an invoice as rejected
 */
export class RejectInvoiceUseCase {
  constructor(private repository: InvoiceRepository) {}

  async execute(invoiceId: number): Promise<InvoiceOperationResult> {
    // Validate invoice ID
    // if (!invoiceId || invoiceId <= 0) {
    //   throw new Error("Valid invoice ID is required");
    // }

    return await this.repository.rejectInvoice(invoiceId);
  }
}
